import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CitiesStoryService, CitiesEventBus } from '@app/modules/cities-module/cities.story';
import { DialogService } from 'primeng/dynamicdialog';
import { DialogIncludesTypes, DialogComponentModel } from '@app/core/models/diallog';
import { DeviceTypes } from '@app/core/classes';
import { CityModel } from '@app/modules/fundamentals-modules/fundamentals.models';
import { CitiesService } from '@app/modules/cities-module/cities.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { _deviceType } from '@app/utils/device';

/**
 * Components.
 */
import { SearchCityComponent } from '@app/modules/cities-module/search-city/search-city.component';

@UntilDestroy()
@Component({
  selector: 'shared-geolocation',
  templateUrl: 'geolocation.component.html',
  styleUrls: [`./geolocation.component.scss`],
})

export class GeolocationComponent implements OnInit {
  public GeolocationValue: CityModel = null;

  constructor(
    private cdr: ChangeDetectorRef,
    private dialogService: DialogService,
    private citiesStory: CitiesStoryService,
    private citiesService: CitiesService
  ) {}

  ngOnInit(): void {
    this.onCitiesStoryBus();
  }

  onCitiesStoryBus(): void {
    this.citiesStory.CitiesEventBus$.pipe(untilDestroyed(this)).subscribe(
      emit => this.onCitiesStoryListener(emit)
    );
  }

  onCitiesStoryListener(emit: CitiesEventBus): void {
    if (emit.event === 'onSelectCityApp') {
      this.GeolocationValue = emit.data;
      this.cdr.markForCheck();
    }

    if (emit.event === 'onUpdateCityApp') {
      emit.cityId ?
        this.GeolocationValue = this.citiesService.onGetCityByDictionary(emit.cityId) :
        this.GeolocationValue = emit.data;

      this.cdr.markForCheck();
    }
  }

  onChangeCity(): void {
    this.dialogService.open(SearchCityComponent, {
      header: 'Выбрать город',
      width: _deviceType() === DeviceTypes.Mobile ? '90%' : '100%',
      styleClass: 'p-dialog__city-search',
      data: <DialogComponentModel>{
        includeType: DialogIncludesTypes.PopupTemplate
      }
    })
  }
}
